<template>
<div :style="columnMargin" class="brand position-relative">
  <img v-if="item.bgImg" class="ajax-cover-bg" :src='item.bgImg' />
  <div class="brand-title-bar">
    <div class="brand-title-name">{{item.title.name}}</div>
    <div @click="toBrandPage(item.title)" class="brand-title-desc">{{item.title.desc}}</div>
  </div>
  <img @click="doLocationHref(brandItem)" v-for="(brandItem, brandIndex) in item.adList" :src="brandItem.imgUrl" :class="['brand-one',{'margin-top-7': brandIndex > 3}]" />
</div>
</template>

<script>
export default { 
  name: 'Brand',
  data() {
    return {
      active: 0,
    }
  },
  props: {
    item: Object,
  },
  components: {
  },
  created() {
  },
  mounted() {
  },
  watch: {
  },
  computed: {
    columnMargin(){
      var obj = {}
      if(this.item.marginObj){
        obj={
          'margin-top': this.item.marginObj.top,
          'margin-bottom': this.item.marginObj.bottom
        }
      }
			return obj
    }
  },
  methods: {
    doLocationHref(obj){
      var self = this
      this.$store.commit('doTrack',{
        href: obj.adHrefUrl,
        columnDefineId: self.item.columnDefineId,
        ccId: obj.ccId,
        adId: obj.adId,
        adName: obj.adName,
        idType: 'adId'
      });
      window.location.href = obj.adHrefUrl
    },
    toBrandPage(titleInfo){
      var self = this
      if(!titleInfo.hrefUrl){
        return
      }
      this.$store.commit('doTrack',{
        href: titleInfo.hrefUrl,
        columnDefineId: self.item.columnDefineId,
        ccId: '',
        adId: titleInfo.columnId,
        adName: titleInfo.name,
        idType: 'btnId'
      });
      window.location.href = titleInfo.hrefUrl
    }
  }
}
</script>

<style scoped>
.brand{
  margin-top: 10px;
  margin-left: 15px;
  width: 345px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.brand-title-bar{
  width: 345px;
  padding: 9px 0 3px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 15px;
  color: #333
}
.brand-title-desc{
  font-size: 10px;
  color: #666;
  padding-right: 13px;
  background: url(/clientmodule/distVueCli/images/new_home_right_icon.png) right center no-repeat;
  background-size: 10px 10px
}
.brand-one{
  width: 78px;
  height: 68px;
  display: block;
  object-fit: contain;
  border-radius: 4px;
  background: #fff
}
.margin-top-7{
  margin-top: 7px
}
</style>